import Header from "../../../component/header/Header";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/logisticaStabilimenti.json";
const LottiAnagrafiche = () => {
  const columns = [
    {
      field: "nomeStabilimento",
      headerName: "Nome dello stabilimento",
      width: 610,
    },
    { field: "tipologia", headerName: "Tipologia", width: 300 },
    { field: "indirizzo", headerName: "Indirizzo", width: 530 },
    { field: "operativoDa", headerName: "Operativo da", width: 130 },
    { field: "utente", headerName: "Utente", width: 85 },
    { field: "azioni", headerName: "Azioni", width: 95 },
  ];

  return (
    <>
      <Header />
      <div className="pageTemplate">
        <Table data={tableData} columns={columns} navData={"lottiAnagrafiche"} />
      </div>
    </>
  );
};

export default LottiAnagrafiche;
